import { useMutation, useQuery } from '@tanstack/react-query'

import useResize from '../../../hooks/useResize'
import { TAGS } from '../../../services/Tags'
import { getCategories } from '../../../services/talents'
import { useEffect, useState } from 'react'
import { LIMIT_OF_CHARACTERS, VIEWPORT_LG } from '../../../utils/constants'
import { ErrorMessage } from '@hookform/error-message'
import { ENGLISH_LEVEL } from '../../../utils/constants/filters'
import Button from '../../../components/Button'
import RegisterFastIconFour from '../../../icons/RegisterFastIconFour'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import DashboardWrapper from '../../Dashboard/components/DashboardWrapper'
import {
  getMyOffersManagementDetail,
  updateJobOfferJuniorByHiring,
} from '../../../services/OfferManagement'
import { useNavigate, useParams } from 'react-router-dom'
import Loader from '../../../components/Loader'

import HelperIconTwo from '../../../icons/HelperIconTwo'
import { useTranslation } from 'react-i18next'
import { getlanguages } from '../../../services/Admin'
import { findRepeatedElements } from '../../../utils'
import DisableTrashIcon from '../../../icons/DisableTrashIcon'
import TrashIcon from '../../../icons/TrashIcon'
//import dayjs from 'dayjs'
import SelectSkills from '../../../components/SelectSkills'
import InnerBanner from '../../../components/InnerBanner'
import { PRIVATE_ROUTES } from '../../../Routes/routes'
import Toast from '../../../components/Toast/Toast'
import Tiptap from '../../../components/Tiptap/Tiptap'

const languagesValues = {
  idLang: '',
  lang_level_id: '',
}

const initialValues = {
  name: '',
  langOffer: [languagesValues],
  skillsOffer: [],
  modalitys: 0,
  description: '',
  activities: '',
  additionalContactInformation: '',
  IdCategorie: 1,
}

const EditJobOfferByJuniors = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    watch,
  } = useForm({ defaultValues: initialValues })

  const {
    fields: languagesFields = [],
    append: appendLanguages = () => {},
    remove: removeLanguages = () => {},
    replace: replaceLanguages = () => {},
  } = useFieldArray({
    control,
    name: 'langOffer',
  })

  const activities = watch('activities')
  const description = watch('description')
  const modalitys = watch('modalitys')
  const langOffer = watch('langOffer')

  const [repeatedLanguages, setRepeatedLanguages] = useState([])
  const [newLanguages] = useState([])
  const listOfLanguages = langOffer
  const lastItemInTheLanguagesArray = langOffer?.[langOffer?.length - 1]
  const transformLanguagesFields = langOffer?.map(({ idLang }) => idLang)

  const { data: listLanguagesData } = useQuery(
    [TAGS.list_of_idioms],
    getlanguages
  )

  const data = watch()
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  const { data: categoriesData = [] } = useQuery(
    [TAGS.categories],
    getCategories
  )

  const {
    data: getMyOffersManagementDetailData = [],
    isFetching: isFetchingGetMyOffersManagementDetail,
    isInitialLoading: isLoadingGetMyOffersManagementDetail,
  } = useQuery(
    [TAGS.offer_management_detail, id],
    () => getMyOffersManagementDetail(id),
    {
      refetchOnWindowFocus: false,
    }
  )

  const { mutate: updateOfferMutate, isLoading: isLoadingUpdateOffer } =
    useMutation(
      ['update-job-offer-junior-by-hiring'],
      updateJobOfferJuniorByHiring,
      {
        onSuccess: async ({ status }) => {
          if (status === 200) {
            await Toast({
              title:
                'Oferta editada correctamente... Redirigiendo al detalle de la oferta',
              timer: 2000,
            })
            navigate(`/offer-juniors-detail/${id}`)
          }
        },
      }
    )

  const [selectedSkills, setSelectedSkills] = useState([])

  const parseSelectedSkills = selectedSkills?.map((skill) => {
    return {
      idSkill: skill?.value,
    }
  })

  const preloadSelectedSkills =
    getMyOffersManagementDetailData?.offert_skills?.map(
      ({ skill_id, skills_categori }) => {
        return {
          label: skills_categori?.skill?.name,
          value: skill_id,
        }
      }
    )

  const transformCurrrentLanguages =
    getMyOffersManagementDetailData?.offert_langs
      ?.filter((props) => Number(props?.lang_level?.id) !== 7)
      ?.map((props) => {
        return {
          idLang: props?.languaje?.id,
          lang_level_id: props?.lang_level?.id,
        }
      })

  const customData = {
    ...data,
    IdCategorie: Number(data?.IdCategorie),
    skillsOffer: parseSelectedSkills,
    langOffer: listOfLanguages.filter((props) => props?.idLang !== ''),
    modalitys: [Number(modalitys)],
    additionalContactInformation: null,
    companyId: getMyOffersManagementDetailData?.company?.id,
    offerId: Number(id),
  }

  const onSubmit = () => {
    if (selectedSkills?.length > 12) {
      return
    }
    updateOfferMutate(customData)
  }

  const handleModalityChange = (event) => {
    const checkboxValue = event.target.value
    setValue('modalitys', checkboxValue)
  }

  useEffect(() => {
    if (getMyOffersManagementDetailData) {
      if (getMyOffersManagementDetailData?.offert_langs?.length > 0) {
        replaceLanguages(transformCurrrentLanguages ?? [])
      }

      setValue('IdCategorie', getMyOffersManagementDetailData?.id_categorie)
      setValue('name', getMyOffersManagementDetailData?.name)
      setValue('activities', getMyOffersManagementDetailData?.activities)
      setValue('description', getMyOffersManagementDetailData?.description)
      setValue(
        'modalitys',
        getMyOffersManagementDetailData?.modality_offerts?.[0]?.modality?.id
      )
      setValue(
        'additionalContactInformation',
        getMyOffersManagementDetailData?.additional_contact_information
      )
      setSelectedSkills(preloadSelectedSkills ?? [])
    }
  }, [getMyOffersManagementDetailData])

  useEffect(() => {
    if (
      lastItemInTheLanguagesArray?.idLang !== '' &&
      lastItemInTheLanguagesArray?.lang_level_id !== ''
    ) {
      appendLanguages(languagesValues)
    }
  }, [
    lastItemInTheLanguagesArray?.idLang,
    lastItemInTheLanguagesArray?.lang_level_id,
  ])

  useEffect(() => {
    setRepeatedLanguages(findRepeatedElements(transformLanguagesFields))
  }, [newLanguages])

  return (
    <>
      <DashboardWrapper>
        {isFetchingGetMyOffersManagementDetail ||
        isLoadingGetMyOffersManagementDetail ? (
          <div className="d-flex align-items-center justify-content-center w-100 h-100">
            <Loader />
          </div>
        ) : (
          <div
            className={`${
              viewportSize[0] <= VIEWPORT_LG ? '' : 'stepper-container'
            } d-flex flex-lg-row flex-column-reverse justify-content-center align-items-center align-items-lg-start p-lg-0 p-3`}
          >
            <div className="w-100">
              <InnerBanner
                className="mb-3"
                before="Ofertas"
                beforeRoute={PRIVATE_ROUTES.list_of_offers_juniors}
                text="Editar Oferta"
              />
              <h2
                className="text-bg-brand d-none d-lg-inline-block"
                style={{
                  fontWeight: 800,
                  marginTop: isMobile ? '' : '90px',
                }}
              >
                {t('edit_offer')}
              </h2>
              <form
                className="border rounded p-4 bg-white"
                style={{
                  marginTop: isMobile ? '' : '40px',
                  width: isMobile ? '100%' : '85%',
                }}
                onSubmit={handleSubmit(onSubmit)}
              >
                <div>
                  <label className="d-flex align-items-center gap-2 form-label text-on-bg-primary">
                    <span>{t('offer_name')}</span>
                    <div
                      title={t(
                        'assign_a_name_so_you_can_identify_your_offers_faster_this_information_will_not_be_visible_to_the_talent'
                      )}
                    >
                      <HelperIconTwo />
                    </div>
                  </label>

                  <input
                    className="form-control"
                    type="text"
                    placeholder={t('assign_a_name_to_the_offer')}
                    {...register('name', {
                      required: t('this_field_is_required'),
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="name"
                    render={({ message }) => (
                      <span className="text-danger font-small">{message}</span>
                    )}
                  />
                </div>
                <div
                  className="sector-company"
                  style={{ marginTop: isMobile ? '17px' : '32px' }}
                >
                  <label className="form-label text-on-bg-primary">
                    {t('position_offered')}
                  </label>
                  <select
                    id="category-select"
                    className="form-control"
                    {...register('IdCategorie', {
                      required: t('this_field_is_required'),
                    })}
                  >
                    <option disabled value="">
                      {t('choose_the_position')}
                    </option>
                    {categoriesData?.map(({ id, name }) => (
                      <option key={id} value={id}>
                        {name}
                      </option>
                    ))}
                  </select>
                  <ErrorMessage
                    errors={errors}
                    name="IdCategorie"
                    render={({ message }) => (
                      <span className="text-danger font-small">{message}</span>
                    )}
                  />
                </div>

                <div style={{ marginTop: isMobile ? '17px' : '32px' }}>
                  <label className="text-on-bg-primary">{t('languages')}</label>
                  <div className="d-flex flex-column-reverse mt-2">
                    {languagesFields.map((item, index) => {
                      return (
                        <li
                          key={item.id}
                          className={`${
                            item?.idLang !== 'gap-1' && 'gap-3'
                          } d-flex flex-row  mb-1 `}
                        >
                          <div className="w-100">
                            <select
                              className="form-control"
                              {...register(`langOffer.${index}.idLang`, {
                                required: {
                                  value:
                                    langOffer?.length <= 1 ||
                                    lastItemInTheLanguagesArray?.lang_level_id !==
                                      '',
                                  message: t('required'),
                                },
                              })}
                            >
                              <option disabled value="">
                                {t('select_a_languages')}
                              </option>
                              {listLanguagesData?.map(({ id, name }) => (
                                <option value={id} key={id}>
                                  {name}
                                </option>
                              ))}
                            </select>
                            <div className="w-25">
                              <ErrorMessage
                                errors={errors}
                                name={`langOffer.${index}.idLang`}
                                render={({ message }) => (
                                  <span className="text-danger font-small">
                                    {message}
                                  </span>
                                )}
                              />
                            </div>
                          </div>
                          <div className="w-100">
                            <select
                              className="form-control sector-company"
                              {...register(`langOffer.${index}.lang_level_id`, {
                                required: {
                                  value:
                                    langOffer?.length <= 1 ||
                                    lastItemInTheLanguagesArray?.idLang !== '',
                                  message: t('required'),
                                },
                              })}
                            >
                              <option disabled value="">
                                Selecciona un nivel
                              </option>
                              {ENGLISH_LEVEL?.map(({ id, name }) => (
                                <option key={id} value={id}>
                                  {name}
                                </option>
                              ))}
                            </select>

                            <div className="w-25">
                              <ErrorMessage
                                errors={errors}
                                name={`langOffer.${index}.lang_level_id`}
                                render={({ message }) => (
                                  <span className="text-danger font-small">
                                    {message}
                                  </span>
                                )}
                              />
                            </div>
                          </div>
                          <div
                            title={t('remove_language')}
                            className="text-secondary cursor-pointer"
                            onClick={() => {
                              if (index === langOffer?.length - 1) return
                              removeLanguages(index)
                            }}
                          >
                            {index === langOffer?.length - 1 ? (
                              <DisableTrashIcon />
                            ) : (
                              <TrashIcon />
                            )}{' '}
                          </div>
                        </li>
                      )
                    })}
                  </div>
                  <div className="d-flex flex-column">
                    {repeatedLanguages.length > 0 && (
                      <span className="text-danger font-small">
                        {t('you_have_repeated_languages')}
                      </span>
                    )}
                    {langOffer?.length < 1 && (
                      <span className="text-danger font-small">
                        {t('minimum_languages', { value: 1 })}
                      </span>
                    )}
                  </div>
                </div>

                <div
                  id="search-for-skills"
                  style={{ marginTop: isMobile ? '17px' : '32px' }}
                >
                  <label className="text-on-bg-primary form-label">
                    {t('required_skills')}
                  </label>
                  <SelectSkills
                    setSelectedSkills={setSelectedSkills}
                    defaultSelectedSkills={preloadSelectedSkills}
                  />
                </div>

                <div
                  className="d-flex flex-column"
                  style={{ marginTop: '32px' }}
                >
                  <label className="form-label text-on-bg-primary">
                    Modalidad
                  </label>
                  <div className="d-flex gap-3">
                    <div className="d-flex align-items-center gap-2">
                      <input
                        checked={true}
                        {...register('modalitys', {
                          required: 'Requerido',
                        })}
                        type="checkbox"
                        className="mycheck"
                        value={2}
                        onChange={handleModalityChange}
                      />
                      <span>{t('remote')}</span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <input
                        {...register('modalitys', {
                          required: 'Requerido',
                        })}
                        checked={Number(modalitys) === 1}
                        type="checkbox"
                        className="mycheck"
                        value={1}
                        onChange={handleModalityChange}
                        disabled
                      />
                      <span
                        style={{
                          color: '#89B5A4',
                        }}
                      >
                        Presencial
                      </span>
                    </div>
                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="modalitys"
                    render={({ message }) => (
                      <span className="text-danger font-small">{message}</span>
                    )}
                  />
                  <span
                    style={{
                      fontSize: '12px',
                    }}
                    className="mt-2 mb-2 text-on-bg-secondary"
                  >
                    Los perfiles en prácticas siempre son 100% remoto.
                  </span>
                </div>
                <div style={{ marginTop: isMobile ? '17px' : '32px' }}>
                  <label className="form-label text-on-bg-primary">
                    Perfil deseado y beneficios adicionales
                  </label>
                  <Controller
                    control={control}
                    name="activities"
                    render={({ field: { onChange, value } }) => (
                      <Tiptap
                        key={value}
                        onChange={onChange}
                        initialValue={value}
                        currentText={activities}
                        limitOfCharacters={LIMIT_OF_CHARACTERS}
                        setComandsTiptap={() => {}}
                      />
                    )}
                    rules={{
                      required: t('this_field_is_required'),
                      validate: (value) => {
                        if (value) {
                          const urlRegex = /(http(s)?:\/\/[^\s]+)/gi
                          if (urlRegex.test(value)) {
                            return t('no_external_links_allowed_in_this_field')
                          }
                        }
                        return true
                      },
                    }}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="activities"
                    render={({ message }) => (
                      <span className="text-danger font-small">{message}</span>
                    )}
                  />
                </div>
                <div style={{ marginTop: isMobile ? '17px' : '32px' }}>
                  <label className="form-label text-on-bg-primary">
                    Descripción del cargo y funciones a realizar
                  </label>
                  <Controller
                    control={control}
                    name="description"
                    render={({ field: { onChange, value } }) => (
                      <Tiptap
                        key={value}
                        onChange={onChange}
                        initialValue={value}
                        currentText={description}
                        limitOfCharacters={LIMIT_OF_CHARACTERS}
                        setComandsTiptap={() => {}}
                      />
                    )}
                    rules={{
                      required: t('this_field_is_required'),
                      validate: (value) => {
                        if (value) {
                          const urlRegex = /(http(s)?:\/\/[^\s]+)/gi
                          if (urlRegex.test(value)) {
                            return t('no_external_links_allowed_in_this_field')
                          }
                        }
                        return true
                      },
                    }}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="description"
                    render={({ message }) => (
                      <span className="text-danger font-small">{message}</span>
                    )}
                  />
                </div>
                <div className="d-flex justify-content-center justify-content-lg-start mt-4 mb-4">
                  <Button
                    className="btn-white border border-on-bg-primary text-on-bg-primary me-2"
                    type="button"
                  >
                    {t('save_as_draft')}
                  </Button>{' '}
                  <Button
                    disabled={isLoadingUpdateOffer}
                    className="btn-bg-CTA-primary"
                    type="submit"
                  >
                    {isLoadingUpdateOffer ? <Loader /> : t('save')}
                  </Button>
                </div>
              </form>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center w-100">
              <RegisterFastIconFour />
              <span
                className={`${
                  viewportSize[0] <= VIEWPORT_LG ? 'w-100' : 'w-50'
                } text-on-bg-secondary text-center mt-4`}
              >
                {t(
                  'say_goodbye_to_manual_talent_search_complete_your_job_offer_and_get_ready_to_meet_your_ideal_candidate'
                )}
              </span>
            </div>
          </div>
        )}
      </DashboardWrapper>
    </>
  )
}

export default EditJobOfferByJuniors
